import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Observable, of} from 'rxjs';
import {GenericApiResponse} from '@webmate-web-core/shared/api/apibase.api';

@Pipe({standalone: true, name: 'errorMsg'})
export class ErrorMessagePipe implements PipeTransform {

    constructor(private translateService: TranslateService) {
    }

    transform(value: string | GenericApiResponse): Observable<string> {
        if (value === undefined) {
            return of("undefined error message");
        }
        if (typeof value === 'string') {
            // this regex is also used in the backend (ErrorId class) and must be kept in sync
            const ERROR_ID_REGEX = /E(I?)([0-9]{3})([0-9]{3})([GNA])/;
            if (ERROR_ID_REGEX.test(value)) {
                return this.translateService.get(`error.${value}`);
            } else {
                return of(value);
            }
        }
        if (!value.code) {
            return of('An unknown error occurred');
        }
        const interpolatedArgs = value.args
            ? Object.fromEntries(
                Object.entries(value.args).map(([key, arg]) => [
                    key,
                    Array.isArray(arg) ? arg.join('\n\t') : arg
                ])
            )
            : value.args;
        return this.translateService.get(`error.${value.code}`, interpolatedArgs);
    }
}
